/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import cx from 'classnames';

import { PrimaryButton } from 'ui';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { basePath, baseAdminPath } from 'constants/urls';
import s from './styles.module.scss';

const sadPiggyUrl = '/sadpiggy.svg';

const Error = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const message = location.state?.message;
  const redirectPath = location.pathname === '/admin/error' ? baseAdminPath : basePath;
  const errorText = location.state?.error?.message;
  const errorMessage = !process.env.PROJECT_ENV && location.state?.errorInfo;
  return (
    <div className={cx(s.error)}>
      <div className={cx(s.errorWrapper)}>
        <div className={cx(s.errorTitle)}>{t('error_title')}</div>
        <div className={cx(s.errorDescription)}>{message || t('error_description')}</div>
        <div className={cx(s.errorDescription)}>{errorText}</div>
        {errorMessage && <div className={cx(s.errorDescription)}>{errorMessage.componentStack.slice(0, 400)}</div>}
        <PrimaryButton className={cx(s.errorButton)} onClick={() => navigate(redirectPath)}>
          {t('error_button_text')}
        </PrimaryButton>
      </div>
      <img className={s.errorImage} src={sadPiggyUrl} alt="Page not found" />
    </div>
  );
};

export default Error;
